import { Component, ReactNode } from 'react';

import { LocalizationProvider } from '@app/components';

import { ErrorBoundaryMessage } from './ErrorBoundaryMessage';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state = { error: null };

  componentDidCatch(error: Error) {
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      return (
        <LocalizationProvider>
          <ErrorBoundaryMessage />
        </LocalizationProvider>
      );
    }

    return this.props.children;
  }
}
